import { defineComponent as _defineComponent } from 'vue'
import AppPage from "@/components/layout/AppPage.vue"
import Tab from "@/components/widgets/Tabs/Tab.vue"
import Tabs from "@/components/widgets/Tabs/Tabs.vue"
import InProgressMissions from "@/modules/Missions/Consultant/InProgressMissions.vue"
import CompletedMissions from "@/modules/Missions/Consultant/CompletedMissions.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'MyMissions',
  setup(__props) {

const tabs = [
  {
    label: "In progress",
    key: "in-progress",
  },
  {
    label: "Completed",
    key: "completed",
  },
]

return { __sfc: true,tabs, AppPage, Tab, Tabs, InProgressMissions, CompletedMissions }
}

})